// Utilities
import { createSimpleFunctional } from "../../util/index.js";
export const VAlertTitle = createSimpleFunctional('v-alert-title');
//# sourceMappingURL=VAlertTitle.js.map